/**
 * Oval Gradient Component
 * Renders the oval-shaped gradient background for idle screen default mode
 * Based on Android specs: 4-color linear gradient
 */

import React from 'react';

interface OvalGradientProps {
  size: 'small' | 'medium'; // 'small' = 4", 'medium' = 5"
}

/**
 * Oval Gradient Component
 * Displays centered oval with 4-color linear gradient
 * Colors: #797979 → #555555 → #313131 → #252525
 */
export const OvalGradient = React.memo(({ size }: OvalGradientProps) => {
  // Dimensions based on screen size
  // 4" (landscape): 311dp × 182dp → ~207px × 121px
  // 5" (portrait): 193.5dp × 291dp → ~129px × 194px
  const dimensions =
    size === 'small'
      ? { width: 207, height: 121 }
      : { width: 129, height: 194 };

  return (
    <div
      className="absolute"
      style={{
        width: `${dimensions.width}px`,
        height: `${dimensions.height}px`,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '50%',
        background: 'linear-gradient(180deg, #797979 0%, #555555 33%, #313131 66%, #252525 100%)',
        zIndex: 20,
      }}
      aria-hidden="true"
    />
  );
});

OvalGradient.displayName = 'OvalGradient';
